module.exports = __webpack_public_path__ + "img/yo-screen-2.858b5fdb.webp";